import { render, staticRenderFns } from "./delete-disease-confirm.vue?vue&type=template&id=41d243fd"
import script from "./delete-disease-confirm.vue?vue&type=script&lang=js"
export * from "./delete-disease-confirm.vue?vue&type=script&lang=js"
import style0 from "./delete-disease-confirm.vue?vue&type=style&index=0&id=41d243fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports